import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import AnimalCauseHero from "./sections/AnimalCauseHero";
import MedicalSpecialties from "./sections/MedicalSpecialties";
import SeguradorasEAcordos from "./sections/SeguradorasEAcordos";
import OurPartners from "./sections/OurPartners";
import AgendeASuaVisita from "./sections/AgendeASuaVisita";
import GetYourStrategy from "./sections/GetYourStrategy";
import OrbitalFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <AnimalCauseHero />
      <MedicalSpecialties />
      <SeguradorasEAcordos />
      <OurPartners />
      <GetYourStrategy />
      <AgendeASuaVisita />
      <OrbitalFooter />
    </div>;
}